import { Theme } from '@mui/material';
/**
 * CcfCustomerCard - used to display quick replies component
 * @param props -?-customerCardDetailsStyles
 * @example <customerCardDetailsStyles />
 */
const simulatorStyles = (theme: Theme) => {
  const simStyles = {
  
    accordionContainer: {
      boxShadow: 'none',
      display: 'block',
    },
  
    accordionHeaderExpand: {
      flexDirection: 'row-reverse',
      paddingLeft: '10px',
      borderTop: `solid ${theme.palette.background.default} 1px`,
      boxShadow: '0px -1px 1px #e7eaec',
    },
    accordionHeader: {
      flexDirection: 'row-reverse',
      paddingLeft: '10px',
    },
    accordionHeaderActivityExpand: {
      flexDirection: 'row-reverse',
      paddingLeft: '10px',
      borderTop: `solid ${theme.palette.background.default} 1px`,
      boxShadow: `-1px 1px 1px #fdeeef`,
    },
    accordionDetailsRoot:{
      display: 'flex',
      padding: '8px 16px 16px',
    },
   
    expandedIcon: {
      transform: 'rotate(180deg)',
      height: '18px',
      width: '20px',
      color: `#5B7C8C`,
    },
   
    hideAccordion: {
      display: 'none',
    },
    mergeIcon: {
      position: 'absolute',
      right: theme.spacing(1),
    },
   
    notesAccordionTitle:{
      fontWeight: '600',
    },
    simLabelStyles:{
      marginLeft: '5px',
      marginRight:'5px',
      display:'flex',
      justifyContent:'space-between',
      marginBottom:'16px'
    }
  };
  return simStyles;
};
export default simulatorStyles;